import React from 'react';
import {navigateHook} from "../../../../../hooks/use-navigate.js";

const ReportContent = ({data, tableColumns}) => {
    const navigate = navigateHook();
    const getCameras = (element) => {
        const cameras = [];

        element.metadata?.cameraId?.toString()?.split(",")?.forEach((id, index) => {
            cameras.push(<span key={`camera-${index}`}>{id}</span>);
        });

        element.metadata?.lane?.toString()?.split(",")?.forEach((id, index) => {
            cameras.push(<a key={`lane-${index}`} onClick={() => navigate(`/lanes?code=${id}`, true)} target="_blank" className="report-link">{id}</a>);
        });

        return cameras.map((item, index) => (
            <React.Fragment key={index}>
                {item}
                {index < cameras.length - 1 && ", "}
            </React.Fragment>
        ));
    };
    const columns = [
        {id: "dt_event_formatted", label: "D/H do evento", className: "w-[15%]", renderCell: element => element.dt_event_formatted},
        {id: "title", label: "Notificação", className: "w-[25%]", renderCell: element => element.title ?? ""},
        {id: "camera_id", label: "ID da câmera", className: "w-[15%]", renderCell: getCameras},
        {id: "plate", label: "Placa", className: "w-[15%]", renderCell: element => (element.metadata?.plate ?? "").replace(",", ", ")},
        {id: "sign", label: "Assinada", className: "w-[10%]", renderCell: element => element.sign ? "Sim" : "Não"}
    ];
    const visibleColumns = columns.filter(column => tableColumns?.[column.id]?.visible !== false);

    return (
        <>
            {visibleColumns.length === 0 && <div className="alert alert-info p-2 h6 text-center mt-[20px]!">Todas as colunas foram ocultadas.</div>}
            <table className={`table report-table ${visibleColumns.length === 0 ? "hidden" : ""}`}>
                <thead className="thead-background print:table-row-group!">
                    <tr className="bg-[#f6f6f6] text-left">
                        {visibleColumns.map(column => <th key={column.id} className={column.className}>{tableColumns?.[column.id]?.label ?? column.label}</th>)}
                    </tr>
                </thead>

                <tbody className="bg-white">
                    {data.map((element, index) => {
                        return (
                            <tr key={index} className="table-break-word">
                                {visibleColumns.map(column => <td key={column.id} className={column.className}>{column.renderCell(element)}</td>)}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </>
    );
};

export default ReportContent;